<div id="loginCreateAccount" class="login-create-account mat-dialog-custom">
  <header class="title-container">
    @if (!options.title) {
      <h1 class="title" i18n>
        Create a free account
        <span class="small-title">to unlock all RIDE COMMAND® features</span>
      </h1>
    } @else {
      <h1 class="title">{{ title }}</h1>
    }
    <button
      id="closeUnlockMoreDialog"
      class="button-link"
      type="button"
      aria-label="Close Dialog"
      mat-dialog-close
      rdxAnalytics="Close Create Account Dialog"
      (click)="closeDialog()"
      i18n-aria-label
    >
      <svg-icon src="/assets/icons/close.svg" alt="close" i18n-alt />
    </button>
  </header>

  <div class="body-container display-flex-container signup-bg">
    <section class="left-container">
      <article class="display-flex-container helper-align-center">
        <figure class="flex-1">
          <svg-icon src="/assets/icons/routes.svg" alt="Plan Rides" i18n-alt />
          <h4 i18n>Plan Rides</h4>
          <p i18n>Create multi-location routes for your RIDE COMMAND® display.</p>
        </figure>
        <figure class="flex-1">
          <svg-icon src="/assets/icons/rides.svg" alt="Track Rides" i18n-alt />
          <h4 i18n>Track Rides</h4>
          <p i18n>Track your rides and share the best with other riders.</p>
        </figure>
        <figure class="flex-1 hide-for-motorcycle">
          <svg-icon src="/assets/icons/group-ride.svg" alt="Group Rides" i18n-alt />
          <h4 i18n>Group Rides</h4>
          <p i18n>Never worry about losing a rider. See everyone right on your map.</p>
        </figure>
      </article>

      <article class="display-flex-container helper-align-center">
        <figure class="flex-1">
          <svg-icon src="/assets/icons/maintenance.svg" alt="Vehicle Care" i18n-alt />
          <h4 i18n>Vehicle Care</h4>
          <p i18n>Log your maintenance to the cloud and never lose another record.</p>
        </figure>
        <figure class="flex-1">
          <svg-icon src="/assets/icons/cell.svg" alt="Mobile App" i18n-alt />
          <h4 i18n>Mobile App</h4>
          <p i18n>Track your ride and bring RIDE COMMAND® along for the adventure.</p>
        </figure>
      </article>
    </section>
    <section class="right-container">
      <rdx-signup-component [navigateTo]="navigateTo" />
    </section>
  </div>
</div>
